// Praia Tropical — beach resorts, surf shops, pousadas tropicais
// Warm sand + turquoise water + coral accent, very rounded
module.exports = {
  effect: 'geometric',
  colors: {
    main:            { light: '#fdf6e3', dark: '#0a2020' },
    card:            { light: '#f5e9c4', dark: '#0f3535' },
    surface:         { light: '#ead5a0', dark: '#164444' },
    action:          { light: '#0e7490', dark: '#22d3ee' },
    actionHover:     { light: '#0c5e75', dark: '#67e8f9' },
    textPrimary:     { light: '#1a1a0a', dark: '#f0fdfb' },
    textSecondary:   { light: '#2d4a2a', dark: '#a7f3d0' },
    textMuted:       { light: '#5c6e4a', dark: '#6ee7b7' },
    textMutedSubtle: { light: '#7a8c68', dark: '#4db8b0' },
    border:          { light: '#b8a870', dark: '#1e5a50' },
    borderSubtle:    { light: '#d4c090', dark: '#154040' },
    link:            { light: '#0e7490', dark: '#22d3ee' },
    linkBg:          { light: '#e0f5f8', dark: 'rgba(14,116,144,0.2)' },
    linkBorder:      { light: '#a5e1ec', dark: '#0c5e75' },
    linkHover:       { light: '#c0ecf4', dark: 'rgba(14,116,144,0.35)' },
    inputBg:         { light: '#fffdf5', dark: '#0f3535' },
    inputBorder:     { light: '#b8a870', dark: '#1e5a50' },
    inputText:       { light: '#1a1a0a', dark: '#f0fdfb' },
    focusRing:       { light: '#0e7490', dark: '#22d3ee' },
    overlay:         { light: 'rgba(10,40,35,0.5)', dark: 'rgba(0,0,0,0.78)' },
    confirm:         { light: '#8a9a68', dark: '#2a5a50' },
    confirmHover:    { light: '#6a7a50', dark: '#3a6a60' },
    confirmText:     { light: '#ffffff', dark: '#f0fdfb' },
    confirmBg:       { light: '#fdf6e3', dark: '#0f3535' },
    confirmBorder:   { light: '#d4c090', dark: '#1e5a50' },
    success:         { light: '#065f46', dark: '#34d399' },
    successHover:    { light: '#022c22', dark: '#10b981' },
    successBg:       { light: '#ecfdf5', dark: 'rgba(6,78,59,0.3)' },
    successText:     { light: '#10b981', dark: '#6ee7b7' },
    successBorder:   { light: '#a7f3d0', dark: '#065f46' },
    error:           { light: '#c2410c', dark: '#fb923c' },
    errorHover:      { light: '#9a3412', dark: '#f97316' },
    errorBg:         { light: '#fff7ed', dark: 'rgba(154,52,18,0.3)' },
    errorText:       { light: '#f97316', dark: '#fdba74' },
    errorBorder:     { light: '#fed7aa', dark: '#7c2d12' },
    info:            { light: '#0369a1', dark: '#38bdf8' },
    infoHover:       { light: '#075985', dark: '#0ea5e9' },
    infoBg:          { light: '#f0f9ff', dark: 'rgba(3,105,161,0.25)' },
    infoText:        { light: '#0ea5e9', dark: '#7dd3fc' },
    infoBorder:      { light: '#bae6fd', dark: '#075985' },
  },
  borderRadius: {
    card:      '36px',
    container: '22px',
    page:      '30px',
    button:    '9999px',
    input:     '16px',
    badge:     '10px',
    full:      '9999px',
  },
  borderWidth: {
    default: '1px',
    thick:   '2px',
    avatar:  '6px',
    device:  '8px',
  },
  textures: {
    main:    { light: '/textures/sandTexture.jpg', dark: '/textures/sandTexture.jpg', size: '800px 800px', blendLight: 'multiply', blendDark: 'overlay', opacityLight: 0.12, opacityDark: 0.18 },
    surface: { light: '', dark: '' },
    card:    { light: '', dark: '' },
  },
};
